import { createApp, type App } from 'vue';
import PermissionRequest from './permission-request.vue';
import AntDesignVue from 'ant-design-vue';

const MOUNT_ID = 'permission-request-vue';

let permissionRequestApp: App<Element> | null = null;
let currentMountEl: HTMLElement | null = null;

function findMountElement(root?: ParentNode): HTMLElement | null {
  if (root) {
    return root.querySelector<HTMLElement>(`#${MOUNT_ID}`);
  }
  return document.getElementById(MOUNT_ID);
}

export type PermissionRequestInitOptions = {
  launcher?: 'button' | 'float';
};

const CONTACT_US_MOUNT_ID = 'contact-us-draver-vue';

function setContactUsHidden(hidden: boolean): void {
  const contactUs = document.getElementById(CONTACT_US_MOUNT_ID);
  if (!contactUs) return;
  contactUs.classList.toggle('hidden', hidden);
}

export function initPermissionRequest(
  root?: ParentNode,
  options: PermissionRequestInitOptions = {},
): void {
  const mountEl = findMountElement(root);
  if (!mountEl) return;

  destroyPermissionRequest();

  mountEl.innerHTML = '';
  const launcher = options.launcher ?? 'button';
  if (launcher === 'float') {
    mountEl.classList.add('consultation-invite');
    setContactUsHidden(true);
  } else {
    mountEl.classList.remove('consultation-invite');
  }

  const app = createApp(PermissionRequest, { launcher });
  permissionRequestApp = app;
  app.use(AntDesignVue).mount(mountEl);
  currentMountEl = mountEl;
}

export function destroyPermissionRequest(): void {
  if (!permissionRequestApp || !currentMountEl) return;

  permissionRequestApp.unmount();
  currentMountEl.innerHTML = '';
  currentMountEl.classList.remove('consultation-invite');
  setContactUsHidden(false);
  permissionRequestApp = null;
  currentMountEl = null;
}
